export default {
    loadedModules: new Set(['common']),
    cachePrefix: 'translations_',
    cacheDuration: 3600 * 1000,

    async initialize() {
        const locale = await this.detectLocale();
        await this.loadModule(locale, 'common');
        window.i18n.locale = locale;
        return locale;
    },

    async detectLocale() {
        try {
            const preferredLanguage = localStorage.getItem('preferred_language');
            if (preferredLanguage) {
                // Also set as cookie if not already set
                if (!document.cookie.includes('preferred_language=')) {
                    const domain = window.location.hostname;
                    document.cookie = `preferred_language=${preferredLanguage};path=/;domain=${domain};max-age=31536000`;
                    console.log('Cookies set from detectLocale:', document.cookie);
                }
                return preferredLanguage;
            }

            const hasPrompted = localStorage.getItem('language_prompt_shown');
            if (hasPrompted) {
                const cachedLocale = this.getFromCache('user_locale');
                if (cachedLocale) {
                    return cachedLocale.data;
                }
            }

            const response = await window.api.call('get', 'user-settings/locale');
            const { locale, source } = response;

            if (!hasPrompted && source !== 'user_settings') {
                localStorage.setItem('language_prompt_shown', 'true');
                window.alert.promptLanguagePreference(locale, '/settings/language');
            } else {
                this.setCache('user_locale', locale);
            }

            return locale;
        } catch (error) {
            console.error('Failed to detect locale:', error);
            return 'en';
        }
    },

    getCurrentLocale() {
        return window.i18n.locale || 'en';
    },

    loadModule(locale, module = 'common') {
        if (this.loadedModules.has(`${locale}:${module}`)) {
            return Promise.resolve();
        }
        const cacheKey = `${this.cachePrefix}${locale}_${module}`;
        const cached = this.getFromCache(cacheKey);
        if (cached) {
            window.i18n.mergeLocaleMessage(locale, cached);
            this.loadedModules.add(`${locale}:${module}`);
            return Promise.resolve();
        }
        return window.api.call('get', `translations/${locale}/${module}`)
            .then(data => {
                const messages = {
                    [module]: data
                };
                window.i18n.mergeLocaleMessage(locale, messages);
                this.loadedModules.add(`${locale}:${module}`);
                this.setCache(cacheKey, messages);
            })
            .catch(error => {
                console.error(`Failed to load translations for ${module}:`, error);
                throw error;
            });
    },

    getFromCache(key) {
        try {
            const cached = localStorage.getItem(key);
            if (!cached) return null;
            const { timestamp, data } = JSON.parse(cached);
            if (Date.now() - timestamp > this.cacheDuration) {
                localStorage.removeItem(key);
                return null;
            }
            return data;
        } catch {
            return null;
        }
    },

    setCache(key, data) {
        try {
            const cacheData = {
                timestamp: Date.now(),
                data,
                source: 'cache'
            };

            if (key === 'user_locale') {
                cacheData.timestamp = Date.now() - (this.cacheDuration / 2);
            }

            localStorage.setItem(key, JSON.stringify(cacheData));
        } catch (error) {
            this.clearOldCache();
        }
    },

    clearOldCache() {
        try {
            Object.keys(localStorage)
                .filter(key => key.startsWith(this.cachePrefix))
                .forEach(key => localStorage.removeItem(key));
        } catch (error) {
            console.error('Cache clearing error:', error);
        }
    }
}
